<template>
	<div class="content">
		<ConHeader></ConHeader>
		<ConFooter></ConFooter>
	</div>
</template>

<script>
import ConHeader from "./ConHeader.vue"
import ConFooter from "./ConFooter.vue"

export default {
  name: 'Content',
  components: {
    ConHeader,ConFooter
  },
}

</script>

<style scoped>
	.content{
		width: 100%;
		background-color:white;
		margin-top: 90px;
		font-size:17px;
	}
</style>